import { updates } from '@/mocks/home';

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-10 md:py-14 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <h2 className="text-xl md:text-2xl font-heading font-bold text-foreground-950 text-center mb-8 md:mb-10">
          最新动态
        </h2>
        <div className="relative">
          <div className="absolute left-[19px] md:left-[23px] top-0 bottom-0 w-px bg-background-300/60"></div>
          <div className="space-y-5 md:space-y-6">
            {updates.map((item, idx) => (
              <div key={idx} className="flex gap-4 md:gap-5 items-start relative">
                <div className="relative z-10 w-[10px] h-[10px] md:w-[12px] md:h-[12px] rounded-full bg-primary-500 mt-1.5 flex-shrink-0 ring-4 ring-background-50"></div>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-2 mb-1">
                    <span className="text-xs text-foreground-500 font-label">{item.date}</span>
                    <span className={`px-2 py-0.5 text-xs rounded-full font-label font-medium whitespace-nowrap ${
                      item.tag === '上新' ? 'bg-primary-100 text-primary-700' :
                      item.tag === '活动' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '功能' ? 'bg-accent-100 text-accent-700' :
                      item.tag === '公告' ? 'bg-secondary-100 text-secondary-700' :
                      item.tag === '里程碑' ? 'bg-primary-100 text-primary-700' :
                      'bg-secondary-100 text-secondary-700'
                    }`}>{item.tag}</span>
                  </div>
                  <p className="text-sm md:text-base text-foreground-800 leading-relaxed">{item.title}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}